// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"ee0bedc8","488":"33d048b4","977":"0c358d2e"}[chunkId] + ".chunk.js";
};